import { LoremIpsum } from 'lorem-ipsum'

export const lipsum = new LoremIpsum()
